import { useLocalSessionId, useMediaTrack } from '@daily-co/daily-react';
import { createContext, useContext, useMemo } from 'react';
import useVoiceActivity from '../hooks/useVoiceActivity';

const VoiceActivityContext = createContext(null);

export function VoiceActivityProvider({ children }) {
  // Conecta com stream real do microfone
  const localSessionId = useLocalSessionId();
  const { persistentTrack } = useMediaTrack(localSessionId, 'audio');

  const stream = useMemo(() => {
    if (!persistentTrack) return null;
    return new MediaStream([persistentTrack]);
  }, [persistentTrack]);

  const voiceState = useVoiceActivity(stream);

  return (
    <VoiceActivityContext.Provider value={voiceState}>
      {children}
    </VoiceActivityContext.Provider>
  );
}

export function useVoiceActivityContext() {
  const context = useContext(VoiceActivityContext);
  if (context === null) {
    throw new Error('useVoiceActivityContext must be used within VoiceActivityProvider');
  }
  return context;
}

